<template>
	<div class="serviceCard">
		<div class='banner'>
			<img src="@static/images/car-t.png" alt />
		</div>

		<div class="list" v-if='list'>
			<div class="item" v-for="item in list">
				<div class="title">激活码</div>
				<div class="number">{{item.activationCode}}<span @click="copyData(item.activationCode)">复制</span></div>
				<div class="endTime">激活截止日：{{item.activateInvalidTime | trustTime01(true)}}</div>
				<div class="validityTime">服务有效期：{{item.cardType | cardType}}</div>
				<div class="btns">
					<div class="btn" @click="getDetails(item)">去激活</div>
					<div class="btn" @click="getLogin(item)">查看详情</div>
				</div>
			</div>
		</div>

		<div class="noData" v-else>
			<img class="noImg" src="@static/images/car-t-no.png" alt="" srcset="">
			<div class="noDesc">
				暂无可领取服务卡
			</div>
		</div>
		<app-loading :loaded="loaded"></app-loading>
	</div>
</template>

<script>
	var vm;
	import loading from "@/components/commons/loading";

	export default {
		data: () => ({
			list: [], //主列表数据
			loaded: true
		}),
		components: {
			"app-loading": loading
		},
		methods: {
			//激活
			getDetails() {
				if(item.activationProvider == 2) {
					if(this.$config.env == 1) {
						// 生产
						location.href = 'https://health-prod-new.medtreehealth.com/landing/wts?entrance=wts'
					} else {
						//测试
						location.href = 'https://health-new.medtreehealth.com/landing/wts?entrance=wts'
					}
					return;
				}
				window.location.href = "https://m.junlinghealth.com/car-t/login/index?bizChannel=wtscart&from_wecom=1";
			},
			//登录
			getLogin() {
				if(item.activationProvider == 2) {
					if(this.$config.env == 1) {
						// 生产
						location.href = 'https://health-prod-new.medtreehealth.com/landing/wts?entrance=wts'
					} else {
						//测试
						location.href = 'https://health-new.medtreehealth.com/landing/wts?entrance=wts'
					}
					return;
				}
				window.location.href = "https://m.junlinghealth.com/car-t/login/index?bizChannel=wtscart&type=login";
			},
			getList() {
				this.$http({
						type: 'GET',
						url: "/policy/coupongive/api/receive/list",
						data: {}
					})
					.then(r => {
						if (r.data && r.data.length) {
							vm.list = r.data;
						} else {
							vm.list = null;
						}
						vm.loaded = true;
					})
					.catch(err => {});
			},

			// 调用浏览器复制功能
			copyData(val) {
				var oInput = document.createElement("input");
				oInput.value = val;
				oInput.readOnly = true;
				document.body.appendChild(oInput);
				oInput.select(); // 选择对象
				document.execCommand("Copy"); // 执行浏览器复制命令
				oInput.className = "oInput";
				oInput.style.display = "none";
				vm.$notice.msg("复制成功");
			},
		},
		created() {
			vm = this;
		},
		mounted() {
			this.getList();
		},
		filters: {
			cardType(type) {
				let val = '';
				switch (type) {
					case 1:
						val = '1年';
						break;
					case 2:
						val = '5年';
						break;
					case 3:
						val = '10年';
						break;
					default:
						break;
				}

				return val;
			},


		}
	};
</script>

<style lang="scss" scoped>
	.serviceCard {
		min-height: 100vh;
		background: #fff;

		.banner {
			img {
				display: block;
				width: 100%;
			}
		}

		.list {
			padding: 0 38px;

			.item {
				margin-top: 29px;
				padding: 28px;
				box-shadow: 0px 6px 30px 0px rgba(60, 70, 79, 0.1);

				.title {
					font-size: 31px;
					font-weight: 500;
					color: #000000;
				}

				.number {
					font-size: 48px;
					font-weight: 600;
					color: #636E92;
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					margin-top: 10px;
					word-break: break-all;

					span {
						font-weight: normal;
						display: inline-block;
						width: 70px;
						line-height: 40px;
						border-radius: 4px;
						border: 1px solid #FF8700;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: 24px;
						color: #FF8700;
						margin-left: 10px;
					}
				}

				.validityTime,
				.endTime {
					color: #8A9095;
					margin-top: 12px;
				}

				.btns {
					display: flex;
					justify-content: flex-end;

					.btn {
						width: 148px;
						line-height: 60px;
						border-radius: 31px;
						border: 1px solid #236DFF;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: 27px;
						color: #236DFF;
						margin-left: 23px;
					}
				}
			}
		}

		.noData {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin-top: 160px;

			.noImg {
				width: 334px;
				display: block;
			}

			.noDesc {
				margin-top: 20px;
				font-size: 31px;
				color: #8A9095;
			}
		}
	}
</style>
